export const French = {
  Features: "Caractéristiques",
  Blog: "Blog",
  Trade: "Échange",
  trade: "echange",
  Buy: "Acheter/Vendre",
  Download: "Télécharger",
  The: "La",
  gateway: "porte",
  to: "d'entrée vers",
  To: "D'entrée vers",
  the: "la",
  next: "prochaine",
  generation: "génération",
  of: "de",
  Gamers: "Joueurs",
  Your: "Vos",
  games: "jeux",
  coins: "pièces",
  All: "Le tout",
  in: "au",
  one: "même",
  place: "endroit",
  Simple: "Simple",
  fun: "amusant",
  and: "et",
  And: "Et",
  super: "super",
  smart: "intelligent",
  Scan: "Scannez",
  app: "l'application",
  Available: "Disponible",
  on: "sur",
  Assets: "D'actifs",
  game: "jeu",
  Game: "Jeu",
  Connect: "Connectez",
  a: "à",
  thirdparty: "un tiers",
  Crypto: "Crypto",
  Card: "Carte",
  Authentication: "Authentification",
  Own: "Possédez",
  your: "vos",
  earn: "gagner",
  is: "est",
  Is: "Est",
  secure: "sécurisé",
  easy: "moyen",
  way: "facile",
  store: "facile",
  manage: "gérer",
  winnings: "gains",
  Whether: "Si",
  youre: "tu es",
  Youre: "Tu es",
  competitive: "compétitif",
  gamer: "joueur",
  or: "ou",
  just: "juste",
  casual: "occasionnel",
  player: "joueur",
  has: "a",
  something: "quelque chose",
  for: "pour",
  everyone: "tout le monde",
  effortlessly: "sans effort",
  converts: "convertit",
  into: "dans",
  preferred: "préférée",
  cryptocurrency: "crypto-monnaie",
  start: "commencer",
  earning: "a gagner",
  Exclusive: "Exclusif",
  exclusive: "Exclusif",
  content: "contenu",
  experiences: "expériences",
  experience: "expérience",
  now: "maintenant",
  at: "à",
  fingertips: "bout des doigts",
  passport: "passeport",
  unlock: "ouvrir",
  favourite: "préférés",
  need: "besoin",
  do: "faire",
  connect: "connecter",
  any: "n'importe lequel",
  other: "autre",
  Gaming: "Jeu",
  Platform: "plate-forme",
  account: "compte",
  Once: "Une fois",
  connected: "Connecté",
  youll: "tu vas",
  Youll: "Tu vas",
  be: "être",
  able: "capable",
  rewards: "récompenses",
  unlocking: "déverrouillage",
  instantly: "immédiatement",
  enjoying: "profiter",
  powered: "alimenté",
  by: "par",
  will: "Va",
  launch: "lancer",
  token: "jeton",
  listing: "liste de",
  major: "majeur",
  coming: "à",
  soon: "venir",
  participate: "participer",
  our: "notre",
  premium: "prime",
  collections: "collections",
  you: "toi",
  You: "Toi",
  must: "doit",
  signup: "s'inscrire",
  get: "être",
  verified: "vérifié",
  buy: "acheter",
  using: "en utilisant",
  respectively: "respectivement",
  Smartest: "Le plus intelligent",
  Safe: "Sûr",
  Secure: "Sécurisé",
  Earn: "Gagner",
  Big: "Gros",
  Join: "Rejoignez",
  Trend: "tendance",
  Dont: "Ne sois",
  left: "laissé",
  behind: "pour compte",
  Welcome: "Bienvenue",
  world: "monde",
  possibilities: "possibilités",
  space: "espace",
  no: "plus",
  longer: "maintenant",
  thing: "chose",
  it: "il",
  It: "Il",
  present: "présente",
  Over: "Plus de",
  invested: "investi",
  projects: "projets",
  past: "passée",
  year: "l'année",
  free: "gratuit",
  easiest: "le plus simple",
  anywhere: "n'importe où",
  anytime: "à tout moment",
  Use: "Utilise",
  accepted: "accepté",
  from: "depuis",
  online: "en ligne",
  globally: "à l'échelle mondiale",
  With: "Avec",
  an: "un",
  instant: "instant",
  cash: "monnaie",
  conversions: "conversions",
  can: "peux",
  spend: "dépenser",
  without: "sans",
  hassles: "tracas",
  top: "top",
  notch: "au",
  security: "sécurité",
  blockchain: "blockchain",
  backbone: "épine dorsale de la",
  assets: "actifs",
  are: "sont",
  always: "toujours",
  safe: "en sécurité",
  perfect: "parfaite",
  most: "la plupart",
  out: "dehors",
  Rewarding: "Récompense",
  complete: "complet",
  control: "contrôle",
  over: "sur",
  funds: "les fonds",
  while: "alors que",
  prioritizing: "prioriser",
  gaming: "jeu",
  back: "dos",
  with: "avec",
  every: "chaque",
  use: "utilisation",
  today: "aujourd'hui",
  level: "niveau",
  up: "supérieur",
  rules: "règles",
  only: "seulement",
  keys: "clés",
  so: "donc",
  Our: "Notre",
  audited: "vérifié",
  audit: "Audit",
  firms: "entreprises",
  constantly: "en permanence",
  reviewed: "examiné",
  ensure: "Fil circulaire",
  maximum: "maximum",
  Convenience: "Commodité",
  moment: "moment",
  WAYS: "FAÇONS",
  AUTHENTICATION: "AUTHENTIFICATION",
  TO: "À",
  STRENGTHEN: "RENFORCER",
  YOUR: "TON",
  ASSETS: "ACTIFS",
  SAFETY: "SÉCURITÉ",
  enjoy: "apprécier",
  all: "tout",
  this: "ça",
  amazing: "incroyable",
  functionalities: "fonctionnalités",
  A: "Un",
  Decentralized: "système décentralisé",
  wallet: "portefeuille",
  dedicated: "dédié",
  Home: "Maison",
  Marketplace: "Marché",
  Privacy: "Confidentialité",
  Policy: "Politique",
  Terms: "Termes",
  Service: "Service",
  Navigation: "La navigation",
  Products: "Des produits",
  Legal: "Légal",
  What: "Quoi",
  How: "Comment",
  blockchains: "blockchains",
  does: "fait",
  support: "soutien",
  types: "les types",
  deposit: "dépôt",
  withdraw: "retirer",
  earned: "gagné",
  my: "mon",
  I: "je",
};
